export default __webpack_public_path__ + "static/media/H9FA4A-min.8af9e842.jpeg";